import React, { useEffect, useState } from 'react';
import Formulario from './formulario';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { ProyectosAdapter } from '../../../../../infraestructure/persistence/rest/ProyectosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';

//00007070
const PROYECTO_MOK = [{
        "code": "25-889-00001",
        "name": "BESS AYORA 72 MWH/2H ",
        "date": "2025-05-23",
        "creatioN_TIME": "2025-05-23 08:54:22",
        "status": "Pdte. decidir",
        "projecT_COUNTRY": "ES",
        "sociedaD_ID": "261",
        "sociedaD_CODE": "00007070",
        "sociedaD_NAME": "ELECNOR SERV.Y PROYECTOS",
        "sociedaD_CIF": "A79486833",
        "sociedaD_RAZON_SOCIAL": "ELECNOR SERVICIOS Y PROYECTOS,SAU",
        "sociedaD_ADDRESS": "MARQUES DE MONDEJAR 00033",
        "sociedaD_CITY": "MADRID",
        "sociedaD_POSTAL_CODE": "28028",
        "sociedaD_COUNTY": "MADRID",
        "sociedaD_COUNTRY": "ES",
        "sociedaD_TYPE": "E",
        "cP_CODE": "889",
        "delegacioN_CODE": "802",
        "diR_NEGOCIO_CODE": "800"
    }]

export const FormularioProyectos = (props: any) => {
	let { handle, selected, onClose, currentUser} = props;

	const api = new ProyectosAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let[proyectoCRM, setProyectoCRM] = useState<any>([]);
	let result: any;

	useEffect(()=>{},[props])

	const resetProyectoCRM=()=>{
		setProyectoCRM([...[]])
	}

	//await {data:PROYECTO_MOK} 
	const getProyectosCRM = async (codigoOferta:string) => {
			try {
				result = await {data:PROYECTO_MOK} //await api.ListarProyectosCRM(codigoOferta);
				if(result.data && result.data!=="")
				{
					setProyectoCRM([ ...result.data]);
					// if(currentUser && currentUser.administraUsuarios)
					// {
					// 	const _result = result.data[0].sociedaD_CODE === '00007070' ? result.data : [];
					// 	setProyectoCRM([..._result])
					// }else{
					// 	setProyectoCRM([ ...result.data]);
					// }
				}else{resultError()}
			} catch (error) {
				let exception = ServerErrorMessage(error);
				exceptionError(exception);
			}
	};

	return <Formulario onSave={handle} selected={selected} onClose={onClose} 
	currentUser={currentUser} onGetProyectosByOferta={getProyectosCRM} 
	proyectoCRM={proyectoCRM[0]!==undefined ? {...proyectoCRM[0]} : undefined} onResetProyectoCRM={resetProyectoCRM}/>;
};

export default FormularioProyectos;